(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/simple-article/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/content/simple-article/assets/javascripts/init.js'); "use strict";

var init = function init() {
  var setupVideoFromAttributes = svs.components.emp_video_player.helpers.client.setupVideoFromAttributes;
  var simpleArticles = document.getElementsByClassName('simple-article');

  for (var index = 0; index < simpleArticles.length; index++) {
    var redbeeVideoElement = simpleArticles[index].querySelectorAll('.js-emp-placeholder');

    for (var _index = 0; _index < redbeeVideoElement.length; _index++) {
      var video = redbeeVideoElement[_index];
      setupVideoFromAttributes(video);
    }
  }
};

init();
 })(window);